var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../../store';
import { updateTheme } from '../../store/slices/roomSettingsSlice';
const themeSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.theme);
$RefreshReg$(_react_refresh_temp_1, "themeSelector$createSelector");
const DarkThemeSwitcher = () => {
    _react_refresh_temp_3();
    const theme = useAppSelector(themeSelector);
    const dispatch = useAppDispatch();
    const toggleDarkMode = () => {
        dispatch(updateTheme(theme === 'light' ? 'dark' : 'light'));
    };
    return (_jsx("div", { className: "dark-mode mt-1", children: _jsx("button", { onClick: toggleDarkMode, children: _jsx(_Fragment, { children: theme === 'dark' ? (_jsx("div", { className: "moon w-8 h-8 rounded-full flex items-center justify-center", children: _jsx("i", { className: "pnm-moon w-4 h-4 text-primaryColor dark:text-secondaryColor" }) })) : (_jsx("div", { className: "sun w-8 h-8 rounded-full flex items-center justify-center", children: _jsx("i", { className: "pnm-sun w-4 h-4 text-primaryColor dark:text-secondaryColor" }) })) }) }) }));
};
_react_refresh_temp_2 = DarkThemeSwitcher;
$RefreshReg$(_react_refresh_temp_2, "DarkThemeSwitcher");
_react_refresh_temp_3(DarkThemeSwitcher, "RAaDm7qnHlZPSN6rrx62x85O5uU=", false, () => [useAppSelector, useAppDispatch]);
export default DarkThemeSwitcher;
